module.exports = __webpack_public_path__ + "media/assets/icons/explanation_of_bulk_quote_1-e9b29264a9022f8570fea478b0bb4b67.svg";